module.exports = __webpack_public_path__ + "static/img/goods-1666.16a35dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-1666.png
// module id = 0nJu
// module chunks = 2